import axios from 'axios';

import { extractData } from '@/api/ApiHelpers';

import type { GridpointListResponse } from '@/api/ApiTypes';


const gridpointGetList = (
	cnetId: number,
	handler: (responseData: GridpointListResponse) => void,
	errorHandler: () => void,
): void => {
	axios.get('/gridpoint/get_list/', { params: { cnet_id: cnetId } })
		.then(extractData(handler)).catch(errorHandler);
};


export default {
	gridpointGetList,
};
